export function makeApiRequest(method, urlsuffix, data, success, error) {

    const { redirectUrl } = APP.store.getState()['features/base/jwt'];
    let url = redirectUrl.replace('/join', '');
    if (APP.boomeaDebug) {
        console.log('customizedmeet before ajax', `${url}/api/v4/${urlsuffix}`, data);
    }
    $.ajax({
        url: `${url}/api/v4/${urlsuffix}`,
        type: method,
        crossDomain: true,
        contentType: 'application/json; charset=UTF-8',
        processData: false,
        data: JSON.stringify(data),
        success: function (response) {
            if (APP.boomeaDebug) {
                console.log('success');
            }
            success(response);
            if (APP.boomeaDebug) {
                console.log('customizedmeet ajx succ:', response);
            }
        },
        error: function (xhr, resp, text) {
            //success(resp);
            if (APP.boomeaDebug) {
                console.log('customizedmeet ajax err1');
                console.log('customizedmeet ajax error', xhr, resp, text);
                console.log(resp);
                console.log(resp.getAllResponseHeaders());
                console.log(xhr.getResponseHeader('Header'));
            }

            error(resp);
        }
    });
}

export function addRoom(data, success, error) {
    makeApiRequest('POST', `meetings/addroom`, data, success, error);
}

export function addUser(data, success, error) {
    makeApiRequest('POST', `meetings/adduser`, data, success, error);
}

export function checkMuted(data, success, error) {
    makeApiRequest('GET', `meetings/checkmuted/${data.id}`, null, success, error);
}

export function updateUser(data, success, error) {
    makeApiRequest('PUT', `meetings/updateuser`, data, success, error);
}

export function meetingsLeft(data, success, error) {
    makeApiRequest('POST', `meetings/left`, data, success, error);
}

export function meetingsLeftAll(data, success, error) {
    makeApiRequest('POST', `meetings/leftall`, data, success, error);
}

export function addCallerUser(data, success, error) {
    makeApiRequest('POST', `meetings/addcalleruser`, data, success, error);
}

export function checkAudioPin(data, success, error) {
    makeApiRequest('POST', `meetings/checkaudiopin/${data.user_id}`, data, success, error);
}

export function leftBrowser(data, success, error) {
    makeApiRequest('POST', `meetings/leftbrowser`, data, success, error);
}

export function kickOut(data, success, error) {
    makeApiRequest('POST', `meetings/kickout/${data.user_id}`, data, success, error);
}

export function checkKickout(data, success, error) {
    makeApiRequest('GET', `meetings/kickout/${data.user_id}`, data, success, error);
}

export function callerLeft(data, success, error) {
    makeApiRequest('POST', `meetings/callerleft/${data.user_id}`, data, success, error);
}

export function muteUser(data, success, error) {
    makeApiRequest('PUT', `meetings/muteuser/${data.user_id}`, data, success, error);
}

export function getMeetingId(data, success, error) {
    makeApiRequest('GET', `meetings/getroom?room_id=${data.room_id}`, null, success, error);
}

export function getMeetingAudioPinDetail(data, success, error) {
    makeApiRequest('GET', `meetings/audiopindetail?room_id=${data.room_id}&pin=${data.pin}`, null, success, error);
}

export function meetingUpdateLastActive(data, success, error) {
    makeApiRequest('PUT', `users/${data.user_id}/meetings/room/updatelastactive`, { room_id: data.room_id }, success, error);
}